import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { environment } from '@environments/environment';
import { RoutePaths } from '@global/routePaths';

export const NavigationGuard: CanActivateFn = (route, state) => {
  const router = inject(Router);
  const currentNav = router.getCurrentNavigation();

  if (environment.environmentName === 'DEV') {
    return true;
  }

  if (currentNav?.id === 1) {
    return true;
  }

  if (currentNav?.trigger === 'popstate' && !currentNav?.extras?.state?.['skipNavGuard']) {
    router.navigateByUrl(RoutePaths.GENERIC_ERROR.route, {
      state: { skipNavGuard: true },
      replaceUrl: true,
    });
    return false;
  }

  return true;
};
